import { api } from '@/api/client';
import { pickMediaUrl } from '@/api/mappers/media';
export async function fetchPublicMenus() {
    const { data } = await api.get('/v1/menus');
    return data;
}
export async function fetchRestaurantsForMenu(menuId) {
    const { data } = await api.get(`/v1/menus/${menuId}/restaurants`);
    return data;
}
export async function fetchRestaurantsByDistance(menuId, address, productIds) {
    const { data } = await api.post(`/v1/menus/${menuId}/restaurants/by-distance`, { address, productIds });
    return {
        restaurants: Array.isArray(data.restaurants) ? data.restaurants : [],
        selectionWarning: data.selectionWarning ?? null,
        addressGeocoded: data.addressGeocoded !== false,
    };
}
function mapPromotion(r) {
    return {
        id: r.id,
        promotionId: r.promotionId,
        title: r.title,
        description: r.description,
        promoCode: r.promoCode ?? null,
        imageUrl: pickMediaUrl(r.media, 'pathBanner', 'path', 'pathThumb'),
    };
}
export async function fetchPromotionsForMenu(menuId) {
    const { data } = await api.get(`/v1/menus/${menuId}/promotions`);
    return data.map(mapPromotion);
}
function mapCombo(r) {
    return {
        id: r.id,
        menuId: r.menuId,
        name: r.name,
        description: r.description,
        price: r.price,
        ingredients: r.ingredients,
        grams: r.grams,
        bonusAmount: r.bonusAmount,
        proteins: r.proteins,
        fats: r.fats,
        carbohydrates: r.carbohydrates,
        calories: r.calories,
        sortOrder: r.sortOrder,
        imageUrl: pickMediaUrl(r.media, 'pathCard', 'pathThumb', 'path'),
        items: r.items,
    };
}
export async function fetchCombosForMenu(menuId) {
    const { data } = await api.get(`/v1/menus/${menuId}/combos`);
    return data.map(mapCombo);
}
